// extracted by mini-css-extract-plugin
export default {"stage5-table":"Stage5_stage5-table__2RJk7","toggle":"Stage5_toggle__1STqy"};